import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { isImage, isVideo, calcuMediaWidth, calcuMediaHeight, resolutions } from '../utils';
import { useTheme, makeStyles, Dialog, Box, Button, DialogContent, DialogActions, Typography, TextField, FormControl } from '@material-ui/core';
import classnames from 'classnames';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import { Close } from '@material-ui/icons';
import { SketchPicker } from 'react-color'
import Iframe from 'react-iframe'
import { baseAuthUrl } from '../authProvider';
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
    DialogContentPresenter: {
        overflow: 'hidden',
        border: '3px solid grey',
        position: "relative",
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    ControlPresenter: {
        padding: '2vh 0'
    },
    send: {
        marginRight: '30px',
        width: '138px',
        height: '36px',
    },

    overlayEditor: {
        position: 'absolute',
        top: 0,
        left: 0,
        margin: 0,
        border: 'none'
    },
    dragItemText: {
        fontFamily: 'UniviaPro',
        position: "absolute",
        top: 0,
        width: 'fit-content',
        padding: 5,
        whiteSpace: 'pre-wrap',
        cursor: 'pointer'
    },
    dialogPaper: {
        maxHeight: '95vh'
    },
    color: {
        width: '36px',
        height: '14px',
        borderRadius: '2px',

    },
    swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
    },
    popover: {
        position: 'absolute',
        zIndex: '2',
        top: '14%'
    },
    cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    },
    fontSize: {
        width: 64,
        "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "none"
        },
        "& input": {
            "-moz-appearance": "textfield",
            padding: '8px 0 0px',
            fontFamily: 'UniviaPro-Book'
        }
    },
    buttonIcon: {
        marginRight: '7px',
        marginTop: '4px',
        minHeight: '24px',
        minWidth: '30px',
        width: '22px',
        height: '24px',
        borderRadius: 3
    },
    colorInherit: {
        background: '#e5f1f8',
        '&:hover': {
            background: '#e5f1f8'
        }
    }
}));

const useOtherStyle = makeStyles({
    zoom: zoomRate => ({
        '-ms-zoom': `${zoomRate.width}`,
        '-moz-transform': `scale(${zoomRate.width}, ${zoomRate.height})`,
        MozTransformOrigin: '0 0', OTransform: `scale(${zoomRate.width}, ${zoomRate.height})`,
        OTransformOrigin: '0 0', WebkitTransform: `scale(${zoomRate.width}, ${zoomRate.height})`,
        WebkitTransformOrigin: '0 0',
        transform: `scale(${zoomRate.width}, ${zoomRate.height})`,
        transformOrigin: '0 0'
    })
});

function Preview({ itemData, pivot, screenSize, resolution }) {
    const filePath = !itemData.owner && !itemData.file ? itemData.fd : baseAuthUrl + "/media/" + itemData.fd;

    if (isImage(itemData.type)) {
        return (
            <img src={filePath}
                style={{
                    transform: `rotate(${itemData.rotate}deg)`,
                    width: `${resolution !== 'No pre-scaling' ? `${screenSize.width + 'px'}` : calcuMediaWidth(itemData.dimension, screenSize, pivot, itemData.rotate, resolution === 'No pre-scaling')}`,
                    height: `${resolution !== 'No pre-scaling' ? `${screenSize.height + 'px'}` : calcuMediaHeight(itemData.dimension, screenSize, pivot, itemData.rotate, resolution === 'No pre-scaling')}`,
                    position: `${resolution === 'No pre-scaling' ? 'absolute' : ''}`,
                    top: `${resolution === 'No pre-scaling' ? 0 : 0}`,
                    bottom: `${resolution === 'No pre-scaling' ? 0 : 0}`,
                    left: `${resolution === 'No pre-scaling' ? 0 : 0}`,
                    right: `${resolution === 'No pre-scaling' ? 0 : 0}`,
                    margin: `${resolution === 'No pre-scaling' ? 'auto' : ''}`
                }} />
        );
    } else if (isVideo(itemData.type)) {
        return (
            <video src={filePath}
                style={{
                    transform: `rotate(${itemData.rotate}deg)`,
                    width: `${resolution !== 'No pre-scaling' ? `${screenSize.width + 'px'}` : calcuMediaWidth(itemData.dimension, screenSize, pivot, itemData.rotate, resolution === 'No pre-scaling')}`,
                    height: `${resolution !== 'No pre-scaling' ? `${screenSize.height + 'px'}` : calcuMediaHeight(itemData.dimension, screenSize, pivot, itemData.rotate, resolution === 'No pre-scaling')}`,
                    position: `${resolution === 'No pre-scaling' ? 'absolute' : ''}`,
                    top: `${resolution === 'No pre-scaling' ? 0 : 0}`,
                    bottom: `${resolution === 'No pre-scaling' ? 0 : 0}`,
                    left: `${resolution === 'No pre-scaling' ? 0 : 0}`,
                    right: `${resolution === 'No pre-scaling' ? 0 : 0}`,
                    margin: `${resolution === 'No pre-scaling' ? 'auto' : ''}`
                }} />
        );
    }
}

const OverlayEditor = (props) => {
    const { open, handleClose, itemData, onChangeOverlay, resolution, pivot } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [stateButton, setStateButton] = useState({});
    const [selected, setSelected] = useState(false);
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const translate = useTranslate();
    const [iframe, setIframe] = useState(null);
    const screenSize = {
        width: pivot ? 360 : 960,
        height: pivot ? 640 : 540
    }
    const zoomRate = {
        width: screenSize.width / (resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 1 : 0] : '1280'),
        height: screenSize.height / (resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 0 : 1] : '720')
    }
    const classes2 = useOtherStyle(zoomRate);

    const addNewText = () => {
        iframe.addItem('text', true);
    }

    const onLoadIframe = () => {
        document.getElementById("overlay-editor").contentWindow.setItemFontSize(resolution ? resolution === '7680x4320' ? 200 : resolution === '3840x2160' ? 100 :
            resolution === '1920x1080' ? 50 : resolution === '1280x720' ? 30 : resolution === '960x540' ? 25 : 30 : 25);
        document.getElementById("overlay-editor").contentWindow.setOverlayHtml(itemData.overlay ? itemData.overlay : '');
        document.getElementById("overlay-editor").contentWindow.emitEvent = function (event, param) {
            switch (event) {
                case 'selectedItem':
                    if (param) {
                        setStateButton({
                            type: 'text',
                            color: param.css('color'),
                            underline: param.css('text-decoration').includes('underline'),
                            bold: param.css('font-family') === 'UniviaPro-Bold',
                            italic: param.css('font-style') === 'italic',
                            fontSize: parseInt(param.css('font-size').replace('px', ''))
                        });
                        setSelected(true);
                    } else {
                        setSelected(false);
                        setStateButton({
                            type: 'text',
                            color: '#ff0000',
                            underline: false,
                            bold: false,
                            italic: false,
                            fontSize: resolution ? resolution === '7680x4320' ? 200 : resolution === '3840x2160' ? 100 :
                                resolution === '1920x1080' ? 50 : resolution === '1280x720' ? 30 : resolution === '960x540' ? 25 : 30 : 25
                        });
                    }
                    break;

                default:
                    break;
            }
        }
        setIframe(document.getElementById("overlay-editor").contentWindow);
    }

    const removeOneItem = () => {
        if (selected) {
            iframe.deleteSelectedItem();
        }
    }

    const removeAllText = () => {
        iframe.clear();
        setSelected(false);
    }

    const changeFontSize = (fontSize) => {
        if (selected) {
            iframe.setItemFontSize(fontSize);
            const data = { ...stateButton };
            data.fontSize = fontSize;
            setStateButton(data);
        }
    }

    const changeColor = (color) => {
        if (selected) {
            iframe.setItemTextColor(color.hex);
            const data = { ...stateButton };
            data.color = color.hex;
            setStateButton(data);
        }
    }

    const toggleBold = () => {
        if (selected) {
            iframe.setFontBold(!stateButton.bold)
            const data = { ...stateButton };
            data.bold = !stateButton.bold;
            setStateButton(data);
        }
    }

    const toggleItalic = () => {
        if (selected) {
            iframe.setFontItalic(!stateButton.italic)
            const data = { ...stateButton };
            data.italic = !stateButton.italic;
            setStateButton(data);
        }
    }

    const toggleUnderline = () => {
        if (selected) {
            iframe.setFontUnderline(!stateButton.underline)
            const data = { ...stateButton };
            data.underline = !stateButton.underline;
            setStateButton(data);
        }
    }

    const onSave = () => {
        const overlay = iframe.getOverlayHtml();
        onChangeOverlay(overlay);
    }

    return (
        <Dialog open={open} scroll='paper' id="dialogEditOverlayPopup" maxWidth={'lg'} classes={{ paper: classes.dialogPaper }}>
            <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                <CloseButton onClick={handleClose} />
            </Box>
            <DialogContent>
                <Box className={classes.ControlPresenter} display="flex" flexWrap="wrap">
                    <Button style={{ fontFamily: 'UniviaPro-Bold', fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', marginRight: theme.spacing(3) }} variant='contained' color='primary' onClick={addNewText} disabled={iframe ? false : true}>{translate('pos.infochannel.addText')}</Button>
                    <Button style={{ fontFamily: 'UniviaPro-Bold', fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', marginRight: theme.spacing(3) }} variant='contained' color='primary' disabled={!selected} onClick={removeOneItem}>{translate('pos.infochannel.remove')}</Button>
                    <Button style={{ fontFamily: 'UniviaPro-Bold', fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', marginRight: theme.spacing(3) }} variant='contained' color='primary' onClick={removeAllText}>{translate('pos.infochannel.removeAll')}</Button>
                    <Typography style={{ fontFamily: 'UniviaPro ', fontSize: '13px', lineHeight: '16.3px', marginRight: theme.spacing(1.5), alignSelf: 'center' }}>{translate('pos.infochannel.fontSize')}:</Typography>
                    <TextField
                        type="number"
                        value={stateButton.fontSize ? stateButton.fontSize : ''}
                        InputProps={{
                            inputProps: { min: 5, max: 99 },
                            className: classes.fontSize
                        }}
                        style={{ marginRight: theme.spacing(3) }}
                        onChange={e => changeFontSize(e.target.value)}
                    />
                    <Typography style={{ fontFamily: 'UniviaPro ', fontSize: '13px', lineHeight: '16.3px', marginRight: theme.spacing(1.5), alignSelf: 'center' }}>{translate('pos.infochannel.color')}:</Typography>
                    <Box style={{ marginRight: theme.spacing(3) }} display='flex' alignItems='center'>
                        <div className={classes.swatch} onClick={() => setDisplayColorPicker(!displayColorPicker)}>
                            <div className={classes.color} style={{ background: stateButton.color }} />
                        </div>
                        {displayColorPicker ?
                            <div className={classes.popover}>
                                <div className={classes.cover} onClick={() => setDisplayColorPicker(false)} />
                                <SketchPicker color={stateButton.color} onChange={changeColor} />
                            </div> : null
                        }
                    </Box>
                    <Button variant="contained"
                        color={stateButton.bold ? "primary" : "inherit"}
                        className={`${classes.buttonIcon} ${!stateButton.bold ? classes.colorInherit : ''}`}
                        onClick={toggleBold}>B
                    </Button>
                    <Button variant="contained"
                        color={stateButton.italic ? "primary" : "inherit"}
                        className={`${classes.buttonIcon} ${!stateButton.italic ? classes.colorInherit : ''}`}
                        onClick={toggleItalic}>I
                    </Button>
                    <Button variant="contained"
                        color={stateButton.underline ? "primary" : "inherit"}
                        className={`${classes.buttonIcon} ${!stateButton.underline ? classes.colorInherit : ''}`}
                        onClick={toggleUnderline}>U
                    </Button>
                </Box>
                <Box
                    id="presenter"
                    className={classes.DialogContentPresenter}
                    style={{
                        width: screenSize.width, height: screenSize.height
                    }}
                >
                    <Box display='flex' alignItems='center' height="100%" justifyContent='center' style={{ backgroundColor: '#000' }}>
                        <Box>
                            <Preview itemData={itemData} pivot={pivot} screenSize={screenSize} resolution={resolution} />
                        </Box>
                    </Box>
                    <Iframe src={process.env.PUBLIC_URL + "/infochannel-overlay-editor.html"}
                        width={resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 1 : 0] : '1280'}
                        height={resolution.split('x').length > 1 ? resolution.split('x')[pivot ? 0 : 1] : '720'}
                        id="overlay-editor"
                        className={classnames(classes.overlayEditor, classes2.zoom)}
                        onLoad={onLoadIframe} />
                </Box>
            </DialogContent>
            <DialogActions>
                <TextButton mr={2} style={{ marginTop: "1em" }} onClick={handleClose} />

                <Button
                    variant="contained"
                    className={classes.send}
                    size="large"
                    color="primary"
                    onClick={onSave}
                >
                    <Typography style={{ fontFamily: 'UniviaPro-Bold', fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px' }}>{translate('pos.common.save')}</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default OverlayEditor
